// extracted by mini-css-extract-plugin
module.exports = {"gridText":"TextImage_gridText__6H0K4","brandLine":"TextImage_brandLine__zsE02","gridImage":"TextImage_gridImage__U4SZy"};